import Router from '@capsule/insite-panel/router'
import GlobalStore from 'shared/globalStore/assets/scripts/globalStore'

import PmcBridge from 'shared/services/pmc-bridge'

export default class insitePanel {
	private store: GlobalStore
	private pmcBridge: PmcBridge
	private isUserConnected: Awaited<ReturnType<typeof PmcBridge.prototype.isConnected>>
	private insitePanel: HTMLElement | null
	private pmcAuthentification: HTMLElement | null
	private legalLinks: string | null | undefined
	private trigram: string | undefined
	private defaultSignUpService: string | undefined

	constructor() {
		this.store = new GlobalStore()
		this.pmcBridge = new PmcBridge()
		this.isUserConnected = false
		this.insitePanel = document.getElementById('insitePanel')
		this.pmcAuthentification = document.getElementById('pmc-authentification')

		if (this.insitePanel && this.store && this.store.brand) {
			this.legalLinks = this.insitePanel.getAttribute('data-legal-links')
			this.trigram = this.store.brand.metadata.trigram.toUpperCase()
			this.defaultSignUpService = `${this.trigram}_COMPTE-PMC_HEADER_SITE-${this.trigram}_SE-CONNECTER`
		}
	}

	async init() {
		this.isUserConnected = await this.pmcBridge.isConnected()
		this.addEvents()
		this.initRouter()
	}

	addEvents() {
		if (!this.isUserConnected) {
			this.pmcAuthentification?.addEventListener('click', this.actionOpenPanel)
		}
	}

	initRouter() {
		if (this.defaultSignUpService && this.legalLinks) {
			const router = new Router({
				defaultSignUpService: this.defaultSignUpService,
				brandLegalLink: this.legalLinks
			})
			router.init()
		}
	}

	actionOpenPanel() {
		document.dispatchEvent(
			new window.CustomEvent('insitePanel', {
				detail: {
					route: '/compte',
					options: {
						title: 'Créez gratuitement votre compte ou connectez-vous',
						queryVars: {
							redirectTo: window.location.href
						}
					}
				}
			})
		)
	}
}
